<div class="modal-header">
  <h4 class="modal-title">Import sessions</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>

<div class="modal-body">
  @for (file of getFiles(); track file) {
    <div>
      <br />
      <p>{{ file.name }}</p>

      @if (!!fileStatus.get(file)) {
        <p>
          @if (!finishedFiles.has(file)) {
            <span>
              <i class="fas fa-circle-notch fa-spin" style="font-size: 22px"></i>
            </span>
          }
          <span>
            {{ fileStatus.get(file) }}
          </span>
        </p>
      }

      @if (!file.isComplete()) {
        <div>
          @if (file.size) {
            <p>
              Uploading {{ file.size | bytes }}
              @if (file.currentSpeed) {
                <span>({{ file.currentSpeed | bytes }}/s)</span>
              }
            </p>
          }

          <p>
            @if (!file.error) {
              <ngb-progressbar [value]="file.progress() * 100" [max]="100"></ngb-progressbar>
            }
          </p>

          @if (flow.timeRemaining()) {
            <p>{{ flow.timeRemaining() | secondspipe }} remaining</p>
          }

          @if (file.error) {
            <div class="alert alert-danger" role="alert">
              <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
              Upload error: {{ file.errorMessage }}
            </div>
          }

          <p>
            @if (!file.isComplete()) {
              <button type="button" class="btn btn-secondary btn-sm" (click)="cancel(file)">
                <i class="fas fa-times" aria-hidden="true"></i>
                Cancel
              </button>
            }
          </p>
        </div>
      }
    </div>
  }
</div>
